import Vue from 'vue'

declare module 'vue/types/vue' {
  interface Vue {
    enter(el: HTMLElement, done: TimerHandler): void;
    leave(el: HTMLElement, done: TimerHandler): void;
  }
}

export default Vue.mixin({
  name: 'Transitions',

  methods: {
    enter: function (el: HTMLElement, done: TimerHandler): void {
      el.style.transition = 'opacity 600ms linear'
			el.style.opacity = '1'
			setTimeout(done, 600)
    },
		leave:function (el: HTMLElement, done: TimerHandler): void {
      el.style.transition = 'opacity 200ms linear'
			el.style.opacity = '0'
			setTimeout(done, 200)
    }
  }
})
